<template>
  <div>
    <div class="layout">
      <div class="inforManagement">
        <div class="layout-header" ref="searchBox">
          <div class="infor-layout-header">
            <span class="title">资料管理</span>
            <p>
              <el-button v-show="checkUserAuth(5, 26)" type="primary" size="small" @click="add" style="margin-right: 1.875rem">上传资料</el-button>
              <!-- <w-upload
                style="display:inline-block;"
                :file-list="list"
                :action="'/api/upload/commonUpload?selfAreaId='+selfAreaId"
                :data="{type:'infomation'}"
                :headers="{Authorization:authorization}"
                :on-success="handleSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </w-upload> -->
            </p>
          </div>
        </div>
        <div style="height:80px;"></div>

        <div class="m16 pagination-bg-white">
          <w-table
            :height="tableViewHeight"
            v-show="checkUserAuth(5, 25)"
            v-loading.body="tableLoading"
            :data-list="tableData"
            :columns="staticData.columns"
            :pageNo="formData.pageNum"
            :pageSize="formData.pageSize"
            :total="total"
            @pageNoChange="pageNoChange"
            @pageSizeChange="pageSizeChange"
            >
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
              <span v-if="props.column.label === '上传时间'">{{ props.row[props.column.property] | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
              <span v-else-if="props.column.label === '所属区域'">{{ props.row.areaName || '全国'}}</span>
              <span v-else-if="props.column.label === '上传者'">{{ props.row.userName}}</span>
              <span v-else-if="props.column.label === '操作'">
                <el-button v-show="checkUserAuth(5, 24)" size="small" type="primary" @click="onShowDialog(props.row)">查看</el-button>
                <el-popconfirm
                  v-show="checkUserAuth(5, 51)"
                  title="确定删除吗？"
                  @confirm="onDel(props.row)"
                  @onConfirm="onDel(props.row)">
                  <el-button slot="reference" size="small" type="danger" style="margin-left:10px;">删除</el-button>
                </el-popconfirm>
              </span>
              <span v-else>{{ props.row[props.column.property]}}</span>
            </template>
          </w-table>
          <div v-show="!checkUserAuth(5, 25)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>

    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="dialogWidth"
      :sureBtnText="sureBtnText"
      :isShowFooter="isShowFooter"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure">
        <template v-slot:content>
          <div class="dialog-content" v-if="detail">
            <div class="content-header">
              <div class="title">{{detail.fileName}}</div>
              <div class="author">
                <span>所属区域：{{detail.areaName || '全国'}}</span>
                <span>上传者：{{detail.userName}}</span>
                <span>格式：{{detail.ext}}</span>
                <span>上传时间：{{detail.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
              </div>
            </div>
            <div class="content-body">
              <iframe :src="filterImage(detail.filePath)" width="100%" height="600"></iframe>
            </div>
          </div>
          <div class="dialog-content" v-if="!detail">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="上传资料" prop="filePath">
                <el-upload
                  :limit="1"
                  style="display:inline-block;"
                  :file-list="list"
                  :action="'/api/upload/commonUpload?selfAreaId='+selfAreaId"
                  :data="{type:'information_upload'}"
                  :headers="{Authorization:authorization}"
                  :on-success="handleSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-remove="handleRemove"
                  >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="文件名称：" prop="fileName">
                <el-input disabled v-model="ruleForm.fileName" maxlength="30" show-word-limit size="small" style="width:50%;"></el-input>
              </el-form-item>
              <el-form-item label="上传者：" prop="userName">
                <el-input disabled v-model="ruleForm.userName" size="small" style="width:50%;"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </template>
    </w-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
import WUpload from '@/components/Update/index.vue'
import staticData from './staticData.js'
import Api from '@/api'
import { mapGetters } from 'vuex'
import {filterImage} from '@/utils/tools'
import store from '@/store'

export default {
  name: 'inforManagement',
  components: {
    WDialog,
    WTable,
    WUpload
  },
  data() {
    return {
      ruleForm: {
        filePath: '',
        fileName: '',
        userName: ''
      },
      rules: {
        filePath: [
          { required: true, message: '请上传资料', trigger: 'blur' }
        ],
        fileName: [
          { required: true, message: '请输入文件名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 30 个字符', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入文件名称', trigger: 'blur' }
        ]
      },
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      sureBtnText: '',
      total: 660,
      tableLoading: false,
      tableData: null,
      dialogTitle: '资料详情',
      dialogWidth: '60%',
      detail: null,
      list: [],
      isShowFooter: true,
      tableViewHeight: ''
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'authorization','userCurrentPage']),
    staticData() {
      return staticData
    }
  },
  created() {
    if (this.userCurrentPage) {
      this.formData.pageSize = this.userCurrentPage
    }
    this.initData()
  },
  methods: {
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 79
      })
    },
    onDel(item) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        id: item.id
      }
      Api.deleteInformation(params)
        .then(res=>{
          if (res.code === 200) {
            vm.$message.success('资料删除成功')
            vm.initData()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    filterImage(url) {
      return filterImage(url)
    },
    handleError(error) {
      console.log(error)
    },
    handleSuccess(rep, file, fileList) {
      console.log(rep, file, fileList)
      this.ruleForm.filePath = rep.data.path
      this.ruleForm.fileTitle = rep.data.fileName
      this.ruleForm.createTime = rep.data.createTime
      this.ruleForm.fileName = file.name
      // this.$message.success('资料上传成功！')
      // this.initData()
    },
    handleRemove() {
      this.ruleForm.filePath = ''
      this.ruleForm.fileTitle = ''
      this.ruleForm.createTime = ''
    },
    beforeAvatarUpload(file) {
      // console.log(file)
      const isFILE = ['application/pdf'].includes(file.type)
      if (!isFILE) {
        this.$message.error('上传文件格式只支持 pdf，请重新上传！')
      }
      return isFILE
    },
    handleProgress(event, file, fileList) {
      console.log(event, file, fileList)
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize
      }
      Api.getList(params)
        .then(res => {
          vm.tableData = res.data.lists
          vm.total = res.data.total
          vm.tableLoading = false
          vm.calcView()
        })
    },
    add() {
      const vm = this
      vm.dialogTitle = '上传资料'
      vm.sureBtnText = '上传'
      vm.isShowFooter = true
      vm.detail = null
      vm.ruleForm.userName = this.user.name
      vm.$refs['w-dialog'].onShowDialog()
    },
    onShowDialog(item) {
      const params = {
        id: item.id,
        selfAreaId: this.selfAreaId
      }
      Api.getDetail(params)
        .then(res => {
          this.detail = res.data
          this.isShowFooter = false
          this.$refs['w-dialog'].onShowDialog()
        })
    },
    onSure() {
      const vm = this

      vm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {
            selfAreaId: vm.selfAreaId
          }
          const data = {
            ...vm.ruleForm,
            areaId: vm.selfAreaId,
            userId: vm.user.id,
            ext: 'PDF'
          }

          Api.addInformation(data, params)
            .then(res => {
              if (res.code === 200) {
                vm.$message.success('资料上传成功！')
                vm.handleClose()
                setTimeout(function() {
                  vm.initData()
                }, 1000)
              } else {
                vm.$message.warning(res.message)
              }
            })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.detail = null
      this.ruleForm.filePath = ''
      this.ruleForm.fileTitle = ''
      this.ruleForm.createTime = ''
      this.ruleForm.fileName = ''
      this.ruleForm.userId = ''
      this.$refs['w-dialog'].onCloseDialog()
    },
    pageNoChange(val) {
      console.log('pageNoChange')
      this.formData.pageNum = val
      this.initData()
    },
    pageSizeChange(val) {
      console.log('pageSizeChange')
      this.formData.pageSize = val
      this.initData()
      store.commit('user/setUserInfo', {
        key: 'userCurrentPage',
        value: val
      })
    }
  }
}
</script>

<style lang="less">
.inforManagement {
  background:rgba(240,242,245,1);
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.dialog-content {
  .content-header{
    padding-bottom: 16px;
    border-bottom: 1px solid #EBEBEB;
    .title {
      font-size:20px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:bold;
      color:rgba(0,0,0,0.85);
      margin-bottom: 16px;
    }
    .author {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      color:rgba(0,0,0,0.45);
      span {
        margin-right: 32px;
      }
    }
  }
  .content-body {
    padding: 16px 0;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    color:rgba(0,0,0,0.45);
  }
}

</style>
